import fetch from '../utilities/fetchAxios'

export const generateFactoryReport = async (query) => {
  return fetch('GET', '/report/v1/factory', query, {}, { responseType: 'blob' }, false)
}
